function a(r = "") {
  return r.length ? r[0].toUpperCase() + r.substr(1) : "";
}
export {
  a as c
};
//# sourceMappingURL=capitalize-iyaz5rT3.mjs.map
